import { IInviteListItemDTO } from 'DTOModels/inviteDTO';

export interface IInvitesFilterTableItemProps {
    item: IInviteListItemDTO;
    onClick: () => void;
}

export const dateMonths = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];
